import { Navigate } from 'react-router-dom'
import { useAuth } from 'context/authentication/useAuth'

export function SettingsIndexRedirect() {
  const { isLimited, isCheckingAuth } = useAuth()
  // Wait for the fresh /me/ response before redirecting; otherwise a stale
  // userType from session storage (e.g. previous Standard user) can send a
  // newly-logged-in Limited user to /settings/team/users, which then bounces
  // them to /not-authorized.
  if (isCheckingAuth) return null
  return <Navigate to={isLimited ? 'notifications' : 'team/users'} replace />
}
